import { EmailErrorType } from 'shared/components/dashboard-mail-editor/types/email-interface'

export const newsletterDefaultErrors: EmailErrorType = {
  body: '',
  fromEmail: '',
  fromName: '',
  subject: '',
  previewText: '',
  attachments: '',
  common: [],
}
